import { Box, Typography, Card, CardContent, Chip, CircularProgress, Divider, Stack } from '@mui/material'
import { useInsumo } from '../../../../shared/context/insumoContext'
import { useEffect } from 'react'
import { useTheme } from '@mui/material/styles'
import moment from 'moment'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import BuildIcon from '@mui/icons-material/Build'
import AssignmentIcon from '@mui/icons-material/Assignment'
import InventoryIcon from '@mui/icons-material/Inventory'
import { useNavigate } from 'react-router'
export default function HistorialInsumoTaskComponent() {
    const { insumoTask, getInsumoTask, insumo, loadingGetInsumoTask } = useInsumo()
    const theme = useTheme()
    const navigate = useNavigate()
    useEffect(() => {
        if (insumo?.hash_code) {
            getInsumoTask(insumo.hash_code)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [insumo?.hash_code])

    const getLocationPath = (asset) => {
        if (!asset?.parent) return asset?.name || 'Sin ubicación'
        
        const path = []
        let current = asset.parent
        
        while (current) {
            path.unshift(current.name)
            current = current.parent
        }
        
        path.push(asset.name)
        return path.join(' / ')
    }

    return (
        <Box sx={{ p: 1.5 }}>
    

            {loadingGetInsumoTask ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 3 }}>
                    <CircularProgress size={24} />
                </Box>
            ) : insumoTask && insumoTask.length > 0 ? (
                <Stack spacing={2}>
                    {insumoTask.map((task) => (
                        <Card
                            key={task.id}
                            sx={{
                                borderRadius: 1.5,
                                boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.06)',
                                transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                                '&:hover': {
                                    transform: 'translateY(-1px)',
                                    boxShadow: '0px 4px 12px rgba(0,0,0,0.1)'
                                },
                                borderLeft: `3px solid ${theme.palette.primary.main}`
                            }}
                        >
                            <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
                                    <Box sx={{ flex: 1 }}>
                                        <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 0.75, fontSize: '0.9rem' }}>
                                            {task.description}
                                        </Typography>
                                        
                                        <Stack direction="row" spacing={0.5} sx={{ flexWrap: 'wrap', gap: 0.5 }}>
                                            {task.OT_number && (
                                                <Chip
                                                    onClick={() => navigate(`/task/wo/detail-ot/${task.ot_hash_code}`)}
                                                    icon={<AssignmentIcon sx={{ fontSize: '14px !important' }} />}
                                                    label={`OT #${task.OT_number}`}
                                                    color="primary"
                                                    size="small"
                                                    variant="outlined"
                                                    sx={{ fontSize: '0.7rem', height: '24px' }}
                                                />
                                            )}
                                            <Chip
                                                icon={<InventoryIcon sx={{ fontSize: '14px !important' }} />}
                                                label={`${task.total_quantity} ${task.unit || 'unidad'}`}
                                                color="secondary"
                                                size="small"
                                                variant="outlined"
                                                sx={{ fontSize: '0.7rem', height: '24px' }}
                                            />
                                            <Chip
                                                label={moment(task.created_at).format('DD/MM/YYYY HH:mm')}
                                                size="small"
                                                variant="outlined"
                                                sx={{ fontSize: '0.7rem', height: '24px' }}
                                            />
                                        </Stack>
                                    </Box>
                                </Box>

                                <Divider sx={{ my: 1 }} />

                                <Box>
                                    <Typography variant="caption" sx={{ fontWeight: 'bold', mb: 0.75, color: 'text.secondary', fontSize: '0.75rem' }}>
                                        Activos asociados:
                                    </Typography>
                                    {task.assets && task.assets.length > 0 ? (
                                        <Stack spacing={0.5}>
                                            {task.assets.map((asset, index) => (
                                                <Box
                                                    key={asset.id || index}
                                                    sx={{
                                                        p: 1,
                                                        borderRadius: 0.75,
                                                        backgroundColor: theme.palette.background.default,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 0.75
                                                    }}
                                                >
                                                    {asset.type === 'location' ? (
                                                        <LocationOnIcon color="primary" sx={{ fontSize: '16px' }} />
                                                    ) : (
                                                        <BuildIcon color="secondary" sx={{ fontSize: '16px' }} />
                                                    )}
                                                    <Box sx={{ flex: 1 }}>
                                                        <Typography variant="body2" sx={{ fontWeight: 'medium', fontSize: '0.8rem' }}>
                                                            {asset.name}
                                                        </Typography>
                                                        <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem' }}>
                                                            {getLocationPath(asset)}
                                                        </Typography>
                                                    </Box>
                                                    <Chip
                                                        label={asset.type === 'location' ? 'Ubicación' : 'Equipo'}
                                                        size="small"
                                                        color={asset.type === 'location' ? 'primary' : 'secondary'}
                                                        variant="outlined"
                                                        sx={{ fontSize: '0.65rem', height: '20px' }}
                                                    />
                                                </Box>
                                            ))}
                                        </Stack>
                                    ) : (
                                        <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                                            Sin activos asociados
                                        </Typography>
                                    )}
                                </Box>
                            </CardContent>
                        </Card>
                    ))}
                </Stack>
            ) : (
                <Box sx={{ textAlign: 'center', py: 3 }}>
                    <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.85rem' }}>
                        No se encontraron tareas donde se haya usado este insumo
                    </Typography>
                </Box>
            )}
        </Box>
    )
}